class DocumentNotAvailableError extends Error {
  constructor(document) {
    const message = `Error, could not get frame elements. The document (for document ${
      document?.label ?? 'NULL'
    }) is not available or no longer available.`;
    super(message);
    this.name = 'DocumentNotAvailableError';
    this.message = message;
  }
}

export default DocumentNotAvailableError;
